module.exports = __webpack_public_path__ + "static/media/taco-1.cadd28e0.jpg";